<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-console`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a2 2 0 012 2v28a2 2 0 01-2 2H26v4h10a1 1 0 011 1v2a1 1 0 01-1 1H12a1 1 0 01-1-1v-2a1 1 0 011-1h10v-4H5a2 2 0 01-2-2V6a2 2 0 012-2h38zm-2 4H7v24h34V8zM19 21a1 1 0 011 1v1h15a1 1 0 011 1v2a1 1 0 01-1 1H20v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1h-3a1 1 0 01-1-1v-2a1 1 0 011-1h3v-1a1 1 0 011-1h2zm12-10a1 1 0 011 1v1h3a1 1 0 011 1v2a1 1 0 01-1 1h-3v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H13a1 1 0 01-1-1v-2a1 1 0 011-1h15v-1a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconConsole',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
